import * as React from "react"
import type { SVGProps } from "react"
const SvgTable = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M3 19V5q0-.82.59-1.41A2 2 0 0 1 5 3h14q.83 0 1.41.59.6.59.59 1.41v14q0 .83-.59 1.41A2 2 0 0 1 19 21H5q-.82 0-1.41-.59A2 2 0 0 1 3 19M19 9H5V5h14zm-5.32 2v8h-3.35v-8zm-5.35 0v8H5v-8zM19 11v8h-3.32v-8z"
    />
  </svg>
)
export default SvgTable
